"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollegeSavingsRefineModal;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _CollegeSavingsModalFormControls = require("./CollegeSavingsModalFormControls");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function CollegeSavingsRefineModal(props) {
  var {
    handleClose,
    snapshot,
    show,
    fetchDataScienceResults
  } = props;

  // Pulling formik context from higher up, which gives us access to formik state
  var {
    errors,
    touched,
    setFieldValue,
    values,
    isSubmitting,
    isValid
  } = (0, _formik.useFormikContext)();
  var handleSubmit = e => {
    e.preventDefault();
    handleClose();
    // The second param we are passing is acting as the 'bag' that formik would usually give to us
    // when doing a handleSubmit. The function below relies on an object containing setFieldValue method, so we provide it
    fetchDataScienceResults(values, {
      setFieldValue: setFieldValue
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(snapshot),
    title: "Edit your inputs & our assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Children"), /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: "children"
  }, fieldArrayProps => {
    var {
      form,
      push,
      remove
    } = fieldArrayProps;
    var {
      values
    } = form;
    var {
      children,
      numOfKids
    } = values;
    var maxKids = numOfKids >= 6;
    var returnArray = [];
    var addOnClick = () => {
      push({
        childAge: '',
        collegeAge: '',
        fundPercent: '',
        collegeTerm: ''
      });
      setFieldValue('numOfKids', "".concat((0, _utils.parseCurrencyString)(null, numOfKids) + 1));
    };
    children.forEach((child, i) => {
      var isFirstChild = i == 0;
      var removeOnClick = () => {
        setFieldValue('numOfKids', "".concat((0, _utils.parseCurrencyString)(null, numOfKids) - 1));
        remove(i);
      };
      returnArray.push(/*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: i
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "align-items-center"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "flex-grow-by-1"
      }, "Child ".concat(i + 1)), !isFirstChild && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(RemoveButton, {
        onClick: removeOnClick
      }))), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.ChildAge, {
        i: i,
        values: values,
        errors: errors,
        touched: touched
      }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.CollegeAge, {
        i: i,
        values: values,
        errors: errors,
        touched: touched
      }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.FundPercent, {
        i: i,
        values: values,
        errors: errors,
        touched: touched
      }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.CollegeTerm, {
        i: i,
        values: values,
        errors: errors,
        touched: touched,
        setFieldValue: setFieldValue
      })));
    });
    if (!maxKids) {
      returnArray.push(/*#__PURE__*/_react.default.createElement(AddButton, {
        key: "add",
        onClick: addOnClick
      }));
    }
    return returnArray;
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h3", null, "Assumed Rates"), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.CollegeInflationRate, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.RateReturn, {
    values: values,
    errors: errors,
    touched: touched
  }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsModalFormControls.CollegeSavings, {
    values: values,
    errors: errors,
    touched: touched
  }))))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "link",
    onClick: () => handleClose(snapshot)
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    disabled: isSubmitting || !isValid,
    onClick: handleSubmit
  }, "Update"))));
}
var RemoveButton = _ref => {
  var {
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "inline",
    className: "btn-inline remove-button",
    onClick: onClick,
    style: {
      alignSelf: 'center'
    }
  }, "Remove ", /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-answer-incorrect"
  }));
};
var AddButton = _ref2 => {
  var {
    onClick
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    variant: "inline",
    className: "btn-inline",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-add"
  }), " Add Another Child");
};